import React from "react";
import { adDeleteBtn, adSecondaryBtn } from "../../pages/admin/adminDashboardTheme";

export default function ConfirmDialog({ open, title, message, confirmLabel, loading, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[4000] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
    >
      <div className="w-full max-w-md rounded-2xl border border-pink-100 bg-white/95 p-6 shadow-[0_0_25px_rgba(250,204,21,0.25)] ring-1 ring-pink-50 transition-all duration-300">
        <h3 id="confirm-title" className="text-lg font-semibold text-[#1e293b]">
          {title || "Confirm"}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{message}</p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <button type="button" onClick={onCancel} disabled={loading} className={`${adSecondaryBtn} text-sm disabled:opacity-50`}>
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`${adDeleteBtn} text-sm disabled:opacity-60`}
          >
            {loading ? "Deleting…" : confirmLabel || "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
